import React from 'react';
import { FONTS } from '../../constants/Fonts';

const OptionSelector = ({
    options = [],
    isShowCorrectOption = false,
    correctOption,
    correctAnswerUser,
    selectedOptionId = null,
    onSelectOption = () => {},
}) => {
    const isCorrectOption = (option) =>
        isShowCorrectOption &&
        option?.id === correctOption &&
        correctOption === correctAnswerUser?.optionId;

    const isSelectedOption = (option) =>
        selectedOptionId != null && option?.id === selectedOptionId;

    return (
        <div
            data-node-id="18423:5103"
            style={{
                position: 'relative',
                zIndex: 5,
                width: '100%',
                display: 'grid',
                gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                columnGap: 16,
                rowGap: 20,
                pointerEvents: 'auto',
            }}
        >
            {options?.map((option) => {
                const correct = isCorrectOption(option);
                const selected = isSelectedOption(option);
                const highlighted = correct || selected;
                return (
                    <div
                        key={option?.id}
                        role="button"
                        tabIndex={0}
                        onClick={(event) => {
                            event.stopPropagation();
                            if (isShowCorrectOption) return;
                            onSelectOption(option);
                        }}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                event.preventDefault();
                                if (!isShowCorrectOption) onSelectOption(option);
                            }
                        }}
                        style={{
                            position: 'relative',
                            zIndex: 1,
                            minHeight: 44,
                            height: 44,
                            width: '100%',
                            border: highlighted ? '1px solid #FFCC00' : '1px solid rgba(255,204,0,0)',
                            borderRadius: 60,
                            padding: '5px 10px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            textAlign: 'left',
                            cursor: isShowCorrectOption ? 'default' : 'pointer',
                            pointerEvents: 'auto',
                            userSelect: 'none',
                            background: highlighted
                                ? 'linear-gradient(90deg, #822AFF 0%, #FF00F2 100%)'
                                : 'rgba(0,0,0,0.7)',
                            boxShadow: 'inset 0px 4px 4px 0px rgba(0,0,0,0.25)',
                            color: '#FFFFFF',
                            boxSizing: 'border-box',
                            overflow: 'hidden',
                        }}
                    >
                        <span
                            style={{
                                width: 26,
                                height: 26,
                                borderRadius: 100,
                                flexShrink: 0,
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                background: 'rgba(255,255,255,0.8)',
                                boxShadow: '0px 4px 4px 0px rgba(0,0,0,0.05)',
                                fontFamily: FONTS.INTER_SEMIBOLD,
                                fontWeight: 600,
                                fontSize: 16,
                                lineHeight: '24px',
                                letterSpacing: 0.8,
                                color: '#000000',
                                pointerEvents: 'none',
                            }}
                        >
                            {option?.label || ''}
                        </span>
                        <span
                            style={{
                                flex: 1,
                                minWidth: 0,
                                fontFamily: FONTS.INTER_SEMIBOLD,
                                fontWeight: 600,
                                fontSize: 16,
                                lineHeight: '24px',
                                letterSpacing: 0.8,
                                color: '#FFFFFF',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                pointerEvents: 'none',
                            }}
                        >
                            {option?.text || ''}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

export default OptionSelector;
